import { Button, Form } from 'react-bootstrap';
import { ChevronRight } from 'react-feather';

import QrCode from './QRCode';
import { GrandIDAuthStatus } from '../../types/auth'; 
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

interface Props {
  signInScanCode?: string | null;
  verificationStatus: GrandIDAuthStatus;
  onRetrySignIn: () => void;
}



function MobileVerification({ signInScanCode, verificationStatus, onRetrySignIn }: Props) {
 
const { t, i18n } = useTranslation();

useEffect(() => {
  if (i18n.language !== 'se') {
    i18n.changeLanguage('se');
  }
}, []);
  return (
    <>
      <div className="mt-4">
        <Form.Label className="fs-h3 font-black d-flex">{t('Sign_in_with_mobile_bankID')}</Form.Label>
        {verificationStatus === GrandIDAuthStatus.PENDING && (
          <>
            <div className="">
              <div className="theme-text">{t('Open_the_BankID_app_in_your_smartphone')}</div>
              <div className="theme-text">{t('Press_scan_QR_code')}</div>
              <div className="theme-text">{t('Scan_the_QR_code')}</div>
            </div>
            <div className="qrcode-wrapper">
              <QrCode qrCode={signInScanCode} />
            </div>
          </>
        )}

        {verificationStatus === GrandIDAuthStatus.FAILED && (
          <>
            <div className="theme-text mb-3 mt-3">
            {t('qr_code_timeout_message')}
              
            </div>
            <div className="d-flex justify-content-center">
              <Button onClick={() => onRetrySignIn()} style={{ textAlign: 'left' }} className="app-btn-primary">
                <ChevronRight /> Try again
              </Button>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default MobileVerification;
